module.exports = __webpack_public_path__ + "img/certificate.f3703185.jpg";